module.exports = __webpack_public_path__ + "img/april-rain.cd7d2efb.jpg";